import PartnerSettings from './PartnerSettings';

window.Vue.component('PartnerSettings', PartnerSettings);
